var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-site"},[_c('div',{staticClass:"my-site-cont"},[_c('MyBreadcrumb')],1),_c('Detail',{attrs:{"isManager":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }